import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Language Redux States
import {
  SEND_MAIL,
  LIST_RATERS,

} from "./actionTypes"
import { ratersSuccess, ratersError } from "./actions"

import {
  onSendMail,
  onRatersInviteList,

} from "helpers/backend_api_helper";



// edit Language
function* sendMail({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onSendMail, data, id);
    yield put(ratersSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersError(error?.response?.data?.message || "Server Error"));
  }
}

// list Language
function* listRatersInvite({ payload: { data, callback } }) {
  try {
    const response = yield call(onRatersInviteList, data);
    yield put(ratersSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersError(error?.response?.data?.message || "Server Error"));
  }
}




function* RatersInviteSaga() {
  yield takeEvery(SEND_MAIL, sendMail);
  yield takeEvery(LIST_RATERS, listRatersInvite);
}

export default RatersInviteSaga;

